import { useAnnouncementDetails, useCreateAnnouncementForm } from '@/app/pages/notifications/announcements/core/_hooks';
import AnnouncementFormDialog from '@/app/pages/notifications/announcements/modal/AnnouncementFormDialog';

type CreateAnnouncementModalProps = {
  show: boolean;
  onClose: () => void;
  /** Duplicar: o comunicado que serve de ponto de partida. */
  duplicateFromId?: string;
};

function CreateAnnouncementModal({ show, onClose, duplicateFromId }: CreateAnnouncementModalProps) {
  const {
    data: source,
    isPending: isLoadingSource,
    isError: hasSourceFailed,
  } = useAnnouncementDetails(duplicateFromId, show);
  // Duplicar sem a origem salvaria um rascunho vazio: com a busca pendente ou falha, Salvar fica bloqueado.
  const isSourceUnavailable = Boolean(duplicateFromId) && (isLoadingSource || hasSourceFailed);

  const { formik, isSaving, isPublishing, saveDraft, publishNow } = useCreateAnnouncementForm(source, onClose);

  const title = duplicateFromId ? 'Duplicar comunicado' : 'Novo comunicado';

  return (
    <AnnouncementFormDialog
      formik={formik}
      isPublishing={isPublishing}
      isSaveBlocked={isSourceUnavailable}
      isSaving={isSaving}
      show={show}
      sourceId={duplicateFromId}
      title={title}
      onClose={onClose}
      onPublish={publishNow}
      onSaveDraft={saveDraft}
    />
  );
}

export default CreateAnnouncementModal;
